import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex space-x-4 mt-2 mb-4" }



const notSelectedButtonClasses = "bg-gray-200 text-gray-700";
const selectedButtonClasses = "bg-blue-500 text-white";


export default /*#__PURE__*/_defineComponent({
  __name: 'TwButtonsYesAndNo',
  props: {
    isActive: { type: [Boolean, null] }
  },
  emits: ["onClickYes", "onClickNo"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
function onClickYes() {
  emit("onClickYes");
}

function onClickNo() {
  emit("onClickNo");
}

function getClassesNo(): Array<string> {
  let classes: Array<string> = [];
  if (props.isActive == null || props.isActive === true) {
    classes = [notSelectedButtonClasses];
  } else if (props.isActive === false) {
    classes = [selectedButtonClasses];
  }
  return classes;
}

function getClassesYes(): Array<string> {
  let classes: Array<string> = [];
  if (props.isActive == null || props.isActive === false) {
    classes = [notSelectedButtonClasses];
  } else if (props.isActive === true) {
    classes = [selectedButtonClasses];
  }
  return classes;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass([getClassesYes(), "px-4 py-2 rounded"]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (onClickYes()))
    }, _toDisplayString(_ctx.$t("yes")), 3),
    _createElementVNode("button", {
      class: _normalizeClass([getClassesNo(), "px-4 py-2 rounded"]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (onClickNo()))
    }, _toDisplayString(_ctx.$t("no")), 3)
  ]))
}
}

})